<template>
  <omk-button
    v-if="whitelabel.omDesign"
    :disabled="loading"
    @click="handleClick"
    button-type="outlined-button"
    button-size="small"
  >
    {{ buttonText }}
  </omk-button>
  <button
    v-else
    class="default-btn-funk"
    :disabled="loading"
    @click="handleClick"
  >
    <p>{{ buttonText }}</p>
  </button>
</template>

<script>
  export default {
    name: 'FunkButton',
    props: {
      buttonText: {
        required: true,
        default: '',
        type: String,
      },
      loading: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    methods: {
      handleClick() {
        if (this.loading) return;
        this.$emit('buttonClicked');
      },
    },
  };
</script>

<style scoped lang="scss">
  .default-btn-funk {
    font-family: Montserrat;
    cursor: pointer;
    display: flex;
    height: 36px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 18px;
    padding-right: 18px;
    justify-content: center;
    align-items: center;
    width: fit-content;
    color: #282828;
    margin: 0;
    &:active {
      border: none;
      p {
        color: #ffffff;
      }
    }
    p {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: -0.21px;
      margin-bottom: 0px;
      &:active {
        color: #ffffff;
      }
    }
  }
</style>
